import React, { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'success') => {
    const id = Date.now() + Math.random();
    setToasts(t => [...t, { id, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div style={{ position: 'fixed', bottom: 100, right: 20, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 360 }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            display: 'flex', alignItems: 'flex-start', gap: 8,
            background: t.type === 'error' ? 'rgba(255,68,68,0.1)' : 'rgba(0,200,150,0.1)',
            border: `1.5px solid ${t.type === 'error' ? 'rgba(255,68,68,0.3)' : 'rgba(0,200,150,0.3)'}`,
            color: t.type === 'error' ? 'var(--red)' : 'var(--green)',
            borderRadius: 'var(--r-md)', padding: '12px 14px', fontSize: 13, fontWeight: 600,
            boxShadow: '0 8px 24px rgba(0,0,0,0.25)', animation: 'fade-up 0.2s ease',
          }}>
            {t.type === 'error' ? <XCircle size={16} style={{ flexShrink: 0, marginTop: 1 }} /> : <CheckCircle size={16} style={{ flexShrink: 0, marginTop: 1 }} />}
            <span>{t.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
